module.exports = __webpack_public_path__ + "static/img/hdw13.53f59c41.png";